// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './utils/override';
window.videojs = require('video.js');
videojs = videojs.default || videojs;
import UepPlayer from './components/UepPlayer.vue';

import VueCookie from 'vue-cookie';
import Vuex from 'vuex';
//import Meta from 'vue-meta';

import VueClipboard from 'vue-clipboard2';
import SocialSharing from 'vue-social-sharing';
import Vuelidate from 'vuelidate';

import 'video.js/dist/lang/fr.js';
import "videojs-hls-quality/dist/videojs-hls-quality.min";
import 'videojs-default/dist/videojs-default.min';
import 'videojs-skin-control-bar/dist/videojs-skin-control-bar.cjs'
import 'videojs-skin-control-bar/dist/lang/fr.js';
import "videojs-export-share/dist/lang/en.js";
import "videojs-export-share/dist/lang/fr.js";
import "videojs-share-social-media/dist/lang/en.js";
import "videojs-share-social-media/dist/lang/fr.js";
import "videojs-info/dist/lang/en.js";
import "videojs-info/dist/lang/fr.js";
import 'videojs-skin-control-bar/dist/videojs-skin-control-bar.css';
import 'video.js/dist/video-js.css';
import './assets/css/skin/custom-theme.css';
import './assets/css/skin/videojs-skinDefault.css';
import './assets/css/style.css';
import "videojs-hls-quality/dist/videojs-hls-quality.css";
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import 'videojs-default/dist/videojs-default.css';
import './filtres/index.js';
import {HTTP,HTTP_STAT} from './core/http/http-common';
import Routing from './core/router/router';
import storage from './storage.js';
import qs from 'qs';
window.qs = qs;
import 'vue-context/dist/css/vue-context.css';
//import 'videojs-vr';

import './utils/hls-plugin'

import "./filtres/index.js";
import VueI18n from 'vue-i18n';

const PlayerCdn = {
  install(Vue) {
    videojs.addLanguage('fr', {
      Mute: 'Désactiver le son',
      Unmute: 'Activer le son',
    });
    Vue.config.productionTip = false;
    window.eventHub = new Vue();
    Vue.use(Vuex);
    if (!Vue.prototype.hasOwnProperty('$i18n')) {
      Vue.use(VueI18n);
    }
    Vue.use(BootstrapVue);
    Vue.use(VueCookie);
    Vue.use(VueClipboard)
    Vue.use(SocialSharing)
    Vue.use(Vuelidate);

    eventHub.$on('error', function(event){
      var code, params, cause;
      code = event.target && event.target.error ? event.target.error.code : event.code;
      cause = event.cause ? event.cause : "Flux de lecture introuvable";
      params = {
        cause: cause,
        exception: code,
        module: 'player',
        error_code: code,
      };
      HTTP.post(Routing.generate('api_log', params)).then(
        function(response) {},
        function(error) {
          console.log(error);
        },
      );
    });


    // Inject some component options
    Vue.mixin({
      created: function () {
        // something logic ...
      },
      methods: {
        getStatsData: function (params) {
          let self = this;
          if (params.client !== undefined) {
            HTTP.get(
              Routing.generate('api_mooc_get_stats_options', { client: params.client }),
            ).then(
              function(resp) {
                storage.hasDataStats = true;
                var data = resp.data;
                storage.stats = {
                  client: params.client,
                  id_object: params.playerOptions.videoId,
                  type_object: 'video',
                  stats_url: data['stats_url'],
                  url: data['url'],
                  value_object: 0,
                  event_object: 'video_init',
                  c_ip: data['c-ip'],
                  s_ip: data['s-ip'],
                  id_cours:resp.data.theme
                };
                if(params.subscriptionOptions && params.subscriptionOptions.hasOwnProperty('email') ){
                  storage.stats.user_id = params.subscriptionOptions.id;
                  storage.stats.email = params.subscriptionOptions.email
                }
                if(params.paramsOptions && params.paramsOptions.isBO === false)
                  self.sendStatsData(params);
              },function(error){
                console.log(error);
              },
            );
          }
        },
        sendStatsData: function (params) {
          var config = storage.stats;
          if (params && params.serviceParam)
          {
            config.value_object = params.serviceParam.p1;
            config.event_object = params.serviceParam.event_object;
          }
          HTTP_STAT.post(config.stats_url,qs.stringify(config), { emulateJSON: true,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
          });
        },
      },
    });
    Vue.component(UepPlayer.name, UepPlayer);

  },
};
/**
 * Auto install
 */
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(PlayerCdn)
}
export default PlayerCdn
export {PlayerCdn}



// WEBPACK FOOTER //
// ./src/player-cdn-library.js